import { PDFBrowser } from "./PDFBrowser";
import "./index.css";

export function App() {
  return (
    <div className="min-h-screen bg-white">
      <PDFBrowser />
    </div>
  );
}

export default App;
